import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'dibs-react-intl';
import styles from '../../styles/main.scss';

// components
import Text from '../inputs/Text';

const messages = defineMessages({
    placeholder: {
        id: 'dc.AddressForm.City.placeholder',
        defaultMessage: 'City*',
    },
});

const CityInput = ({
    value,
    autoFocus,
    fieldSize,
    isBlurred,
    disabled,
    error,
    onChange,
    onBlur,
    disableAutocomplete,
}) => {
    const intl = useIntl();
    return (
        <Text
            name="city"
            dataTn="city"
            value={value}
            wrapperClass={styles.leftGroup}
            placeholder={intl.formatMessage(messages.placeholder)}
            autoComplete="address-level2"
            autoFocus={autoFocus}
            fieldSize={fieldSize}
            isBlurred={isBlurred}
            disabled={disabled}
            disableAutocomplete={disableAutocomplete}
            error={error}
            onChange={onChange}
            onBlur={onBlur}
        />
    );
};

CityInput.propTypes = {
    value: PropTypes.string.isRequired,
    error: PropTypes.string,
    autoFocus: PropTypes.bool,
    fieldSize: PropTypes.oneOf(['small', 'medium', 'large']),
    isBlurred: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    disableAutocomplete: PropTypes.bool,
};

CityInput.defaultProps = {
    autoFocus: false,
    onBlur() {},
};

export default CityInput;
